<template>
	<div id="pageRoot">

		<!-- TEXTS ----------------------------------------------------------------------------------------------------->
		<span class="normalTheme pageInstruction" style="left: 54px; top: 50px">
				<p>Lee las palabras de las tarjetas.</p>
		</span>

		<span class="normalTheme pageInstruction" style="left: 54px; top: 90px">
				<p>Presta atención a la rima.</p>
		</span>

		<div class="basicItem01" id="card01" style="background-image: url(/pages/img/sordo/svgPage66CardBackground.svg); 
		background-repeat: no-repeat; background-position: center">
			<img src="/pages/img/sordo/svgPage66Canilla.svg" style="height: auto;width: 100%; margin-top: 13.41%">
			<p class="textBase" id="card01Text">
				CANILLA
			</p>
		</div>

		<div class="basicItem01" id="card02">
			<img id="card03Background" src="/pages/img/sordo/svgPage66CardBackground.svg">
			<img id="card03Front" src="/pages/img/sordo/svgPage66FlyingDog.svg">
			<p class="textBase" id="card03Text">
				VOLAR
			</p>
		</div>
		<div class="basicItem01" id="card03">
			<img id="card06Background" src="/pages/img/sordo/svgPage66CardBackground.svg">
			<img id="card06Front" src="/pages/img/sordo/svgPage66Trees.svg">
			<p class="textBase" id="card06Text">
				CERRO
			</p>
		</div>

<!--
		<div class="basicItem01" id="card04">
			<img id="card04Background" src="/pages/img/sordo/svgPage66CardBackground.svg">
			<img id="card04Front" src="/pages/img/sordo/svgPage66JumpingDog.svg">
			<p class="textBase" id="card04Text">
				SALTAR
			</p>
		</div>

		<div class="basicItem01" id="card05">
			<img id="card05Background" src="/pages/img/sordo/svgPage66CardBackground.svg">
			<img id="card05Front" src="/pages/img/sordo/svgPage66Moth.svg">
			<p class="textBase" id="card05Text">
				POLILLA
			</p>
		</div>
		<div class="basicItem01" id="card03">
			<img id="card02Background" src="/pages/img/sordo/svgPage66CardBackground.svg">
			<img src="/pages/img/sordo/svgPage63Dog.svg" style="height: auto;width: 100%; margin-top: 31.59%; z-index: 3;">
			<p class="textBase" id="card02Text">
				PERRO
			</p>
		</div>

	-->
	<p class="textBase" id="text03">
		Escribe las palabras de las tarjetas que ya leíste en el lugar que<br>
		corresponde, según su rima.
	</p>

	<img src="/pages/img/sordo2/assets_p67/flecha.svg" style="
    position: absolute;
    width: auto;
    height: 250px;
    top: 340px;
    z-index: 2;
    left: 15px;" />

	<div 
	style="
	position: absolute;
	background-color: #ED1C24;
	width: 238px;
	height: 50px;
	top: 530px;
	left: 107px;
	">
	<p class="textBase center" style="color: white; font-size: 32px;">AMARILLA</p>
	</div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="0"
      id="inputField01"
      defaultText="CANILLA"
      disabled
      style="
      position: absolute;
      width: 217px;
      height: 30px;
      left: 108px;
      top: 594px;"
    />

    <div 
    style="
    position: absolute;
    background-color: #ED1C24;
    width: 238px;
    height: 50px;
    top: 530px;
    left: 382px;
    ">
    <p class="textBase center" style="color: white; font-size: 32px;">CANTAR</p>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
    />

    <div 
    style="
    position: absolute;
    background-color: #ED1C24;
    width: 238px;
    height: 50px;
    top: 530px;
    left: 665px;
    ">
    <p class="textBase center" style="color: white; font-size: 32px;">BERRO</p>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

	<!-- TEXTS ----------------------------------------------------------------------------------------------------->

	<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	<span class="footer-page footer-write"></span>
	<!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
	</div>
</template>
<style scoped>

#card01 
{
position: absolute;
width: 152.04px;
height: 197.1px;
left: 150px;
top: 200px;
z-index: 3;
}

#card01Text {
position: absolute;
width: 147px;
height: 52px;
left: 5.04px;
top: 137.44px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

#card02 
{
position: absolute;
width: 134.31px;
height: 197.1px;
left: 420px;
top: 160px;
}
#card02Background
{
position: absolute;
height: 100%;
width: auto;
z-index: -2;
transform: rotate(-3.5deg);
}
#card02Text 
{
position: absolute;
width: 121px;
height: 51px;
left: 7px;
top: 153.66px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

#card03 
{
position: absolute;
width: 164.33px;
height: 229.03px;
left: 670px;
top: 185px;
}
#card03Background
{
position: absolute;
width: 121.17px;
height: 195.59px;
left: 16.73px;
top: 33.43px;
z-index: -2;
}
#card03Front
{
position: absolute;
width: 164.33px;
height: 144.4px;
left: 0px;
top: 0px;
}
#card03Text 
{
position: absolute;
width: 121px;
height: 51px;
left: 15px;
top: 167px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

#card04 
{
position: absolute;
width: 129.99px;
height: 215.91px;
left: 535px;
top: 120px;
}
#card04Background
{
position: absolute;
width: 128.82px;
height: 200.23px;
left: 1.17px;
top: 15.68px;
z-index: -2;
transform: rotate(-3deg);
}
#card04Front
{
position: absolute;
left: 0%;
right: 4.41%;
top: 0%;
bottom: 32.2%;
}
#card04Text 
{
position: absolute;
width: 122px;
height: 51px;
left: 1px;
top: 162px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

#card05 
{
position: absolute;
width: 157px;
height: 206px;
left: 687px;
top: 128px;
}
#card05Background
{
position: absolute;
width: 126.09px;
height: 198.6px;
left: 17px;
top: 0px;
z-index: -2;
transform: rotate(2deg);
}
#card05Front
{
position: absolute;
left: 0%;
right: 5.81%;
top: 4.37%;
bottom: 35.7%;
}
#card05Text 
{
position: absolute;
width: 150px;
height: 52px;
left: 7px;
top: 154px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

#card06 
{
position: absolute;
width: 139.86px;
height: 207.71px;
left: 862.84px;
top: 128.16px;
}
#card06Background
{
position: absolute;
width: 139.86px;
height: 207.71px;
left: 0px;
top: 0px;
z-index: -2;
transform: rotate(-5.6deg);
}
#card06Front
{
position: absolute;
left: 7.98%;
right: 5.6%;
top: 11%;
bottom: 31.23%;
}
#card06Text 
{
position: absolute;
width: 122px;
height: 52px;
left: 15.16px;
top: 153.84px;
font-size: 33px;
line-height: 45px;
text-align: center;
}

.textBase 
{
margin:0px;
z-index: 3;
font-family: Open Sans, sans-serif;
font-style: normal;
font-weight: normal;
font-size: 24px;
line-height: 33px;
color: #000000;
}

#text01 
{
/* Lee en voz alta las palabras de las tarjetas */
position: absolute;
left: 11.72%;
right: 40.53%;
top: 1.17%;
bottom: 94.66%;
}

#text02 
{
/* Presta atención a la rima */
position: absolute;
left: 11.72%;
right: 40.53%;
top: 6.12%;
bottom: 89.71%;
}

#text03 
{
/* Escribe las palabras de las tarjetas que ya leíste en el lugar que corresponde, según su rima */
position: absolute;
left: 12%;
right: 13.18%;
top: 56%;
bottom: 46.22%;
}


#text04 
{
/* POLILLA */
position: absolute;
left: 15.53%;
right: 71.09%;
top: 61.33%;
bottom: 31.12%;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}

#text05 
{
/* CANILLA */
position: absolute;
left: 14.94%;
right: 70.7%;
top: 70.05%;
bottom: 23.18%;

font-style: italic;
font-size: 33px;
line-height: 45px;
text-align: center;
color: #00A5A5;
}

#text06 
{
/* SALTAR */
position: absolute;
left: 41.99%;
right: 44.63%;
top: 61.33%;
bottom: 31.12%;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}

#text07 
{
/* PERRO */
position: absolute;
left: 69.24%;
right: 17.38%;
top: 61.33%;
bottom: 31.12%;

font-size: 33px;
line-height: 45px;
text-align: center;
color: #FFFCFC;
}

#inputField01 {
  position: absolute;
  width: 217px;
  height: 30px;
  left: 383px;
  top: 594px;
}
#inputField02 {
  position: absolute;
  width: 217px;
  height: 30px;
  left: 383px;
  top: 658px;
}
#inputField03 {
  position: absolute;
  width: 217px;
  height: 30px;
  left: 665px;
  top: 594px;
}
#inputField04 {
  position: absolute;
  width: 217px;
  height: 30px;
  left: 665px;
  top: 658px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["p66/V43.mp4", "p66/V44.mp4"]
    }
  }
}
</script>